"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const i18n_js_1 = __importDefault(require("i18n-js"));
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const apiService_1 = __importDefault(require("../../../../common/services/apiService"));
const Wrapper = styled_components_1.default.div `
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10vh;

  h3,
  p {
    text-align: center;
  }

  h3 {
    font-size: 4vmin;
    font-weight: 400;
    margin-top: 4vmin;
    margin-bottom: 1.7vmin;
  }

  p:first-of-type {
    margin-top: 0px;
    font-size: 3.2vmin;
    margin-bottom: 1.3vmin;
  }

  .text {
    margin-bottom: 5vmin;
    font-size: 2.74vmin;
    margin-top: 0;
  }

  img {
    display: block;
    margin: 0 auto;
    height: 7vmin;
  }
`;
const DISPLAY_TIME = 10 * 1000;
const ProcessCompleted = ({ stayId, currentLocale, setShowDefaultError, baseUrl, history, }) => {
    const timeout = (0, react_1.useRef)(null);
    const [displayData, setDisplayData] = (0, react_1.useState)({});
    const [countDown, setCountDown] = (0, react_1.useState)(DISPLAY_TIME / 1000);
    const goToKioskStartPage = () => {
        history.push(`${baseUrl}/guest_journey/kiosk`);
    };
    (0, react_1.useEffect)(() => {
        const token = localStorage.getItem("kioskUserToken");
        apiService_1.default
            .keyCardActivationCompleted(currentLocale, token, stayId)
            .then((data) => {
            if (data.status === "success") {
                setDisplayData(data);
                timeout.current = setTimeout(() => {
                    goToKioskStartPage();
                }, DISPLAY_TIME);
            }
            else {
                setShowDefaultError(true);
            }
        })
            .catch(() => {
            setShowDefaultError(true);
        });
        const interval = setInterval(() => {
            setCountDown((prevCounter) => prevCounter - 1);
        }, 1000);
        return () => {
            clearTimeout(timeout.current);
            clearInterval(interval);
        };
    }, []);
    return (react_1.default.createElement(Wrapper, null,
        displayData.icon && (react_1.default.createElement("img", { src: displayData.icon, alt: "activation-success" })),
        displayData && displayData.texts && displayData.texts.headline && (react_1.default.createElement("h3", null, displayData.texts.headline)),
        displayData && displayData.texts && displayData.texts.hint && (react_1.default.createElement("p", null, displayData.texts.hint)),
        displayData && displayData.texts && displayData.texts.text && (react_1.default.createElement("p", { className: "text" }, displayData.texts.text)),
        react_1.default.createElement("p", null, i18n_js_1.default.t("guest_journey_key_card_successful_count_down", {
            countDownValue: countDown,
        }))));
};
const mapStoreToProps = (store) => ({
    baseUrl: store.getValue("baseUrl"),
    currentLocale: store.getValue("currentLocale"),
    stayId: store.getValue("stayId"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(ProcessCompleted));
